import React from "react";
import { Box, Hidden, Container as MuiContainer, ContainerProps as MuiContainerProps } from "@material-ui/core";

interface ContainerProps extends MuiContainerProps {
  bgColor?: string;
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
}
export const Container: React.FC<ContainerProps> = ({ children, bgColor, maxWidth }) => {
  return (
    <Box bgcolor={bgColor} height="100%">
      <Hidden only="xs">
        <MuiContainer maxWidth={maxWidth} fixed>
          {children}
        </MuiContainer>
      </Hidden>
      <Hidden smUp>
        <MuiContainer maxWidth={maxWidth} disableGutters>
          {children}
        </MuiContainer>
      </Hidden>
    </Box>
  );
};
